import { Component, OnDestroy, OnInit } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { LiftStatsComponent } from '../lift-stats/lift-stats.component';

@Component({
	selector: 'app-lift-stats-r7',
	styleUrls: ['./lift-stats-r7.component.css'],
	templateUrl: './lift-stats-r7.component.html'
})
export class LiftStatsR7Component extends LiftStatsComponent implements OnInit {
	constructor(protected analyticsService: AnalyticsService, protected analyticsDataModel: AnalyticsDataModel) {
		super(analyticsService, analyticsDataModel);
	}

	ngOnInit(): void {
		this.requestData();
	}
}
